(function () {
  'use strict';

  var bodyEl = document.body;
  var behavior =
    (bodyEl && bodyEl.dataset && bodyEl.dataset.cartBehavior) || 'page';
  var atcBehavior =
    (bodyEl && bodyEl.dataset && bodyEl.dataset.atcBehavior) || 'popup';

  var drawerEl = document.getElementById('kg-cart-drawer');
  var backdropEl = drawerEl
    ? drawerEl.querySelector('[data-cart-backdrop]')
    : null;
  var itemsEl = drawerEl
    ? drawerEl.querySelector('[data-cart-items]')
    : null;
  var subtotalEl = drawerEl
    ? drawerEl.querySelector('[data-cart-subtotal]')
    : null;
    var errorEl = drawerEl
    ? drawerEl.querySelector('[data-cart-error]')
    : null;
  var liveRegionEl = drawerEl
    ? drawerEl.querySelector('[data-cart-live-region]')
    : null;
  var errorTimer = null;

  var debounceTimers = Object.create(null);
  var pendingQty = Object.create(null);
  var activeRequests = Object.create(null);

  var DEBOUNCE_MS = 250;

  var refreshPromise = null;
  var refreshQueued = false;
  var lastTriggerEl = null;

  var productJsonCache = Object.create(null);

  // ─────────────────────────────────────────────
  // Helpers
  // ─────────────────────────────────────────────

  function cssEscape(value) {
    if (
      window.CSS &&
      typeof window.CSS.escape === 'function'
    ) {
      return window.CSS.escape(String(value));
    }

    return String(value).replace(/(["\\])/g, '\\$1');
  }

  function getItemEl(line) {
    if (!itemsEl) return null;

    return itemsEl.querySelector(
      '[data-line="' + cssEscape(line) + '"]'
    );
  }

  function normalizeQty(value) {
    var qty = Math.floor(Number(value));

    if (!isFinite(qty)) {
      qty = 1;
    }

    return Math.max(1, qty);
  }

  /*
   * Fokus robust setzen.
   *
   * Prüft:
   * - Element vorhanden
   * - echtes DOM-Element
   * - noch mit Dokument verbunden
   * - focus() verfügbar
   *
   * Dadurch werden Fokusfehler durch
   * entfernte / veraltete Elemente reduziert.
   */
  function safeFocus(element) {
    if (
      !element ||
      element.nodeType !== 1 ||
      !element.isConnected ||
      typeof element.focus !== 'function'
    ) {
      return;
    }

    try {
      element.focus({
        preventScroll: true
      });
    } catch (err) {
      try {
        element.focus();
      } catch (focusErr) {
        console.warn(
          'Cart drawer focus failed',
          focusErr
        );
      }
    }
  }

  // ─────────────────────────────────────────────
  // Error / Live Feedback
  // ─────────────────────────────────────────────

  function showCartError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
    clearTimeout(errorTimer);
    errorTimer = setTimeout(function () {
      errorEl.hidden = true;
    }, 6000);
  }

  function clearCartError() {
    if (errorEl) errorEl.hidden = true;
  }

  function announce(message) {
    if (liveRegionEl) liveRegionEl.textContent = message;
  }

  // ─────────────────────────────────────────────
  // Quantity Queue / Debounce
  // ─────────────────────────────────────────────

  function scheduleChange(line, quantity) {
    quantity = normalizeQty(quantity);

    pendingQty[line] = quantity;

    updateLineDisplay(line, quantity);

    if (debounceTimers[line]) {
      clearTimeout(debounceTimers[line]);
    }

    debounceTimers[line] = setTimeout(function () {
      delete debounceTimers[line];
      commitLatestChange(line);
    }, DEBOUNCE_MS);
  }

  function commitLatestChange(line) {
    if (activeRequests[line]) {
      if (!debounceTimers[line]) {
        debounceTimers[line] = setTimeout(function () {
          delete debounceTimers[line];
          commitLatestChange(line);
        }, 120);
      }

      return;
    }

    if (pendingQty[line] === undefined) {
      return;
    }

    commitChange(line, pendingQty[line]);
  }

  function commitChange(line, quantity) {
    activeRequests[line] = true;

    fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: line,
        quantity: quantity
      })
    })
            .then(function (cart) {
        activeRequests[line] = false;
        clearCartError();

        var itemEl = getItemEl(line);
        if (itemEl) itemEl.classList.remove('is-loading');

        var latestQty = pendingQty[line];

        var hasNewerChange =
          latestQty !== undefined &&
          latestQty !== quantity;

        if (hasNewerChange) {
          updateSubtotalFromCart(cart);
          commitLatestChange(line);
        } else {
          delete pendingQty[line];
          patchLineFromCart(cart, line);
        }

        dispatchCartCount(cart.item_count);
      })
            .catch(function (err) {
        activeRequests[line] = false;
        delete pendingQty[line];

        console.warn(
          'Cart update failed',
          err
        );

        var failedItemEl = getItemEl(line);
        if (failedItemEl) failedItemEl.classList.remove('is-loading');

        showCartError(
          'Ihre Änderung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.'
        );

        requestCartRefresh({
          preservePending: true
        }).catch(function () {});
      });
  }

  // ─────────────────────────────────────────────
  // Partial Cart Update
  // ─────────────────────────────────────────────

  function patchLineFromCart(cart, changedLine) {
    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {
      return;
    }

    var item = null;

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === changedLine) {
        item = cart.items[i];
        break;
      }
    }

    /*
     * Artikel wurde entfernt.
     * Deshalb kompletten Cart rendern.
     */
    if (!item) {
      renderCart(cart, {
        preservePending: true
      });

      return;
    }

    var itemEl = getItemEl(changedLine);

    if (!itemEl) {
      renderCart(cart, {
        preservePending: true
      });

      return;
    }

    var input =
      itemEl.querySelector('[data-qty-input]');

    if (input) {
      input.value = String(item.quantity);
    }

    var linePriceEl =
      itemEl.querySelector('.kg-cart-item-price');

    if (linePriceEl) {
      linePriceEl.textContent =
        formatMoney(item.final_line_price);
    }

    var unitPriceEl =
      itemEl.querySelector('[data-unit-price]');

    if (unitPriceEl) {
      unitPriceEl.textContent =
        formatMoney(item.final_price);

      unitPriceEl.setAttribute(
        'data-cents',
        String(item.final_price)
      );
    }

    updateSubtotalFromCart(cart);
  }

    var subtotalNetEl = drawerEl
    ? drawerEl.querySelector('[data-cart-subtotal-net]')
    : null;

  function updateSubtotalFromCart(cart) {
    if (
      subtotalEl &&
      cart
    ) {
      subtotalEl.textContent =
        formatMoney(cart.total_price);
    }

    if (
      subtotalNetEl &&
      cart
    ) {
      var netCents = Math.round(
        (Number(cart.total_price) || 0) / 1.19
      );
      subtotalNetEl.textContent =
        formatMoney(netCents);
    }
  }

  /*
   * Optimistisches UI:
   * Preis und Menge sofort anzeigen,
   * noch bevor Shopify geantwortet hat.
   */
  function updateLineDisplay(line, quantity) {
    var itemEl = getItemEl(line);

    if (!itemEl) {
      return;
    }

    var input =
      itemEl.querySelector('[data-qty-input]');

    if (
      input &&
      String(input.value) !== String(quantity)
    ) {
      input.value = String(quantity);
    }

    var unitPriceEl =
      itemEl.querySelector('[data-unit-price]');

    var linePriceEl =
      itemEl.querySelector('.kg-cart-item-price');

    if (
      unitPriceEl &&
      linePriceEl
    ) {
      var unitCents = parseInt(
        unitPriceEl.getAttribute('data-cents') || '0',
        10
      );

      if (unitCents >= 0) {
        linePriceEl.textContent =
          formatMoney(
            unitCents * quantity
          );
      }
    }
  }

  // ─────────────────────────────────────────────
  // Header Cart Button
  // ─────────────────────────────────────────────

  function onHeaderCartClick(e) {
    if (
      behavior !== 'drawer' ||
      !drawerEl
    ) {
      return;
    }

        e.preventDefault();

    lastTriggerEl =
      e.currentTarget || e.target;

    /*
     * Drawer sofort öffnen (0 wahrgenommene Latenz),
     * dann im Hintergrund den aktuellen Cart laden.
     *
     * Der Drawer zeigt zunächst den serverseitig
     * gerenderten Stand; requestCartRefresh ersetzt
     * ihn direkt danach durch den frischen Cart.
     */
    openDrawer();

    requestCartRefresh({
      preservePending: true
    }).catch(function () {});
  }

  // ─────────────────────────────────────────────
  // Drawer Open / Close
  // ─────────────────────────────────────────────

  function openDrawer() {
    if (!drawerEl) {
      return;
    }

    drawerEl.setAttribute(
      'aria-hidden',
      'false'
    );

    drawerEl.classList.add('is-open');

    document.documentElement.classList.add(
      'kg-cart-open'
    );

    if (document.body) {
      document.body.classList.add(
        'kg-cart-open'
      );
    }

    /*
     * Fokus nach dem Render-Zyklus
     * in den Drawer setzen.
     */
    window.requestAnimationFrame(function () {
      if (
        !drawerEl ||
        drawerEl.getAttribute('aria-hidden') !== 'false'
      ) {
        return;
      }

      var focusTarget =
        drawerEl.querySelector(
          '[data-cart-close], button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );

      safeFocus(focusTarget);
    });
  }

  function closeDrawer() {
    if (!drawerEl) {
      return;
    }

    /*
     * Trigger zuerst lokal sichern.
     * Danach globale Referenz löschen.
     *
     * Dadurch arbeiten wir nicht später
     * mit einem möglicherweise veralteten
     * lastTriggerEl.
     */
    var triggerToRestore =
      lastTriggerEl;

    lastTriggerEl = null;

    drawerEl.setAttribute(
      'aria-hidden',
      'true'
    );

    drawerEl.classList.remove('is-open');

    document.documentElement.classList.remove(
      'kg-cart-open'
    );

    if (document.body) {
      document.body.classList.remove(
        'kg-cart-open'
      );
    }

    /*
     * Fokus erst im nächsten Frame
     * zurücksetzen.
     *
     * So können zuerst Drawer-Klassen
     * und ARIA-Status aktualisiert werden.
     */
    if (triggerToRestore) {
      window.requestAnimationFrame(function () {
        safeFocus(triggerToRestore);
      });
    }
  }

  // ─────────────────────────────────────────────
  // Fetch
  // ─────────────────────────────────────────────

  function fetchJSON(url, options) {
    var opts = Object.assign(
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      },
      options || {}
    );

    /*
     * Header separat zusammenführen,
     * damit Accept nicht durch
     * Content-Type überschrieben wird.
     */
    opts.headers = Object.assign(
      {
        Accept: 'application/json'
      },
      (options && options.headers) || {}
    );

    return fetch(url, opts)
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Request failed: ' +
              response.status
          );
        }

        return response.json();
      });
  }

  // ─────────────────────────────────────────────
  // Cart Refresh Queue
  // ─────────────────────────────────────────────

  function requestCartRefresh(options) {
    options = options || {};

    /*
     * Wenn bereits ein Refresh läuft,
     * keinen zweiten parallelen Request starten.
     */
    if (refreshPromise) {
      refreshQueued = true;

      return refreshPromise;
    }

    refreshPromise =
      fetchJSON('/cart.js')
        .then(function (cart) {
          renderCart(cart, {
            preservePending:
              options.preservePending !== false
          });

          return cart;
        })
        .catch(function (err) {
          console.warn(
            'Cart fetch failed',
            err
          );

          throw err;
        })
        .finally(function () {
          refreshPromise = null;

          /*
           * Falls während des Requests
           * erneut ein Refresh angefordert
           * wurde, jetzt einmal nachholen.
           */
          if (refreshQueued) {
            refreshQueued = false;

            requestCartRefresh({
              preservePending: true
            }).catch(function () {});
          }
        });

    return refreshPromise;
  }

  // ─────────────────────────────────────────────
  // Money Formatting
  // ─────────────────────────────────────────────

  function formatMoney(cents) {
    var amountNumber =
      (Number(cents) || 0) / 100;

    var locale = 'de-DE';

    try {
      var pageLang =
        (
          document.documentElement &&
          document.documentElement.lang
        ) || '';

      if (pageLang) {
        locale = pageLang;
      }
    } catch (e) {}

    var absFormatted =
      new Intl.NumberFormat(
        locale,
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(
        Math.abs(amountNumber)
      );

    return (
      (amountNumber < 0 ? '-' : '') +
      absFormatted +
      ' €'
    );
  }

  // ─────────────────────────────────────────────
  // Security Helpers
  // ─────────────────────────────────────────────

  function escapeHtml(str) {
    if (str == null) {
      return '';
    }

    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeHref(url) {
    if (!url) {
      return '#';
    }

    try {
      var parsed =
        new URL(
          url,
          window.location.origin
        );

      if (
        parsed.protocol !== 'http:' &&
        parsed.protocol !== 'https:'
      ) {
        return '#';
      }

      return parsed.href;
    } catch (e) {
      return '#';
    }
  }

  // ─────────────────────────────────────────────
  // Compare-at Price
  // ─────────────────────────────────────────────

  function getVariantCompareAtPrice(
    handle,
    variantId
  ) {
    if (!handle) {
      return Promise.resolve(null);
    }

    /*
     * Nur hier benötigt,
     * daher bewusst lokaler Scope.
     */
    function findCompare(
      product,
      targetVariantId
    ) {
      if (
        !product ||
        !Array.isArray(product.variants)
      ) {
        return null;
      }

      var variant =
        product.variants.find(
          function (vv) {
            return (
              String(vv.id) ===
              String(targetVariantId)
            );
          }
        );

      return (
        variant &&
        variant.compare_at_price
          ? variant.compare_at_price
          : null
      );
    }

    if (productJsonCache[handle]) {
      return Promise.resolve(
        findCompare(
          productJsonCache[handle],
          variantId
        )
      );
    }

    return fetch(
      '/products/' +
        encodeURIComponent(handle) +
        '.js',
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'product json'
          );
        }

        return response.json();
      })
      .then(function (product) {
        productJsonCache[handle] =
          product;

        return findCompare(
          product,
          variantId
        );
      })
      .catch(function () {
        return null;
      });
  }

  // ─────────────────────────────────────────────
  // Full Cart Render
  // ─────────────────────────────────────────────

  function renderCart(cart, options) {
    if (!itemsEl) {
      return;
    }

    options = options || {};

    if (!options.preservePending) {
      pendingQty =
        Object.create(null);
    }

    itemsEl.innerHTML = '';

    if (
      !cart ||
      !Array.isArray(cart.items) ||
      cart.items.length === 0
    ) {
      var empty =
        document.createElement('p');

      empty.className =
        'kg-cart-empty';

      empty.textContent =
        (
          window.themeStrings &&
          window.themeStrings.cart_empty
        ) ||
        'Ihr Warenkorb ist leer';

      itemsEl.appendChild(empty);
    } else {
      cart.items.forEach(
        function (item) {
          var article =
            document.createElement(
              'article'
            );

          article.className =
            'kg-cart-item';

          article.setAttribute(
            'data-cart-item',
            ''
          );

          article.setAttribute(
            'data-line',
            item.key
          );

          var hasPendingQty =
            pendingQty[item.key] !==
            undefined;

          var displayQty =
            hasPendingQty
              ? pendingQty[item.key]
              : item.quantity;

          var optionsHtml = '';

          var optionPairs =
            Array.isArray(
              item.options_with_values
            )
              ? item.options_with_values.filter(
                  function (ov) {
                    if (!ov) {
                      return false;
                    }

                    var name =
                      String(
                        ov.name || ''
                      );

                    var value =
                      String(
                        ov.value || ''
                      );

                    return (
                      name.toLowerCase() !==
                        'title' &&
                      value.toLowerCase() !==
                        'default title'
                    );
                  }
                )
              : [];

          if (optionPairs.length) {
            optionsHtml =
              '<ul class="kg-cart-item-opts">' +
              optionPairs
                .map(function (ov) {
                  return (
                    '<li>' +
                    escapeHtml(
                      ov.name
                    ) +
                    ': ' +
                    escapeHtml(
                      ov.value
                    ) +
                    '</li>'
                  );
                })
                .join('') +
              '</ul>';
          } else if (
            item.variant_title &&
            item.variant_title !==
              'Default Title'
          ) {
            optionsHtml =
              '<div class="kg-cart-item-options">' +
              escapeHtml(
                item.variant_title
              ) +
              '</div>';
          }

          var skuHtml =
            item.sku
              ? '<div class="kg-cart-item-sku">SKU: ' +
                escapeHtml(
                  item.sku
                ) +
                '</div>'
              : '';

          var itemUrl =
            safeHref(item.url);

          var imageUrl =
            item.image
              ? safeHref(
                  item.image
                )
              : '';

          /*
           * Ohne pendingQty:
           * Shopifys final_line_price.
           *
           * Bei pendingQty:
           * lokale optimistische Berechnung.
           */
          var linePrice =
            hasPendingQty
              ? Number(
                  item.final_price || 0
                ) * displayQty
              : Number(
                  item.final_line_price || 0
                );

          article.innerHTML = [
            '<a class="kg-cart-item-image" href="' +
              escapeHtml(itemUrl) +
              '">',

            imageUrl
              ? '<img class="kg-cart-item-img" src="' +
                escapeHtml(imageUrl) +
                '" alt="">'
              : '',

            '</a>',

            '<div class="kg-cart-item-main">',

            '<a class="kg-cart-item-title" href="' +
              escapeHtml(itemUrl) +
              '">' +
              escapeHtml(
                item.product_title
              ) +
              '</a>',

            optionsHtml,

            skuHtml,

            '<div class="kg-cart-item-unit">',

            '<span class="money" data-unit-price data-cents="' +
              Number(
                item.final_price || 0
              ) +
              '">' +
              formatMoney(
                item.final_price
              ) +
              '</span>',

            '<span class="money kg-cart-item-compare" data-compare-price style="display:none"></span>',

            '</div>',

            '<div class="kg-cart-item-price money">' +
              formatMoney(linePrice) +
              '</div>',

            '<div class="kg-cart-qty">',

            '<button type="button" class="kg-cart-qty-btn" data-qty-decrease aria-label="Menge verringern">−</button>',

            '<input class="kg-cart-qty-input" data-qty-input type="number" inputmode="numeric" min="1" value="' +
              displayQty +
              '">',

            '<button type="button" class="kg-cart-qty-btn" data-qty-increase aria-label="Menge erhöhen">＋</button>',

                        '<button type="button" class="kg-cart-remove" data-remove aria-label="Artikel entfernen"></button>',

            '</div>',

            '</div>'
          ].join('');

          itemsEl.appendChild(
            article
          );

          var setCompare =
            function (compare) {
              var compareEl =
                article.querySelector(
                  '[data-compare-price]'
                );

              if (
                !compareEl ||
                !document.contains(
                  article
                )
              ) {
                return;
              }

              if (
                compare &&
                compare >
                  item.final_price
              ) {
                compareEl.style.display =
                  '';

                compareEl.textContent =
                  formatMoney(compare);
              } else {
                compareEl.style.display =
                  'none';
              }
            };

          if (
            item.compare_at_price
          ) {
            setCompare(
              item.compare_at_price
            );
          } else {
            getVariantCompareAtPrice(
              item.handle,
              item.variant_id
            ).then(setCompare);
          }
        }
      );
    }

    updateSubtotalFromCart(cart);

    dispatchCartCount(
      cart
        ? cart.item_count
        : 0
    );
  }

  // ─────────────────────────────────────────────
  // Cart Count Event
  // ─────────────────────────────────────────────

  function dispatchCartCount(
    itemCount
  ) {
    window.dispatchEvent(
      new CustomEvent(
        'cartcount:update',
        {
          detail: {
            item_count:
              itemCount,

            /*
             * Wichtig:
             * eigenes Event kennzeichnen,
             * damit der Listener unten
             * keinen Refresh-Loop erzeugt.
             */
            source:
              'kg-cart-drawer'
          }
        }
      )
    );
  }

  // ─────────────────────────────────────────────
  // Item Helpers
  // ─────────────────────────────────────────────

  function getLineFromTarget(
    target
  ) {
    if (
      !target ||
      target.nodeType !== 1
    ) {
      return null;
    }

    var itemEl =
      target.closest
        ? target.closest(
            '[data-cart-item]'
          )
        : null;

    return itemEl
      ? itemEl.getAttribute(
          'data-line'
        )
      : null;
  }

  function getCurrentQty(line) {
    if (
      pendingQty[line] !==
      undefined
    ) {
      return pendingQty[line];
    }

    var itemEl =
      getItemEl(line);

    if (!itemEl) {
      return 1;
    }

    var input =
      itemEl.querySelector(
        '[data-qty-input]'
      );

    return input
      ? normalizeQty(
          input.value
        )
      : 1;
  }

  // ─────────────────────────────────────────────
  // Drawer Clicks
  // ─────────────────────────────────────────────

  function onDrawerClick(e) {
    var target = e.target;

    if (
      !target ||
      target.nodeType !== 1
    ) {
      return;
    }

    if (
      target.closest &&
      target.closest(
        '[data-cart-close]'
      )
    ) {
      closeDrawer();
      return;
    }

    if (
      target === backdropEl
    ) {
      closeDrawer();
      return;
    }

    var line =
      getLineFromTarget(
        target
      );

    if (!line) {
      return;
    }

    if (
      target.matches(
        '[data-qty-increase]'
      )
    ) {
      scheduleChange(
        line,
        getCurrentQty(line) + 1
      );
    } else if (
      target.matches(
        '[data-qty-decrease]'
      )
    ) {
      scheduleChange(
        line,
        Math.max(
          1,
          getCurrentQty(line) - 1
        )
      );
    } else if (
      target.matches(
        '[data-remove]'
      )
    ) {
      if (
        debounceTimers[line]
      ) {
        clearTimeout(
          debounceTimers[line]
        );

        delete debounceTimers[
          line
        ];
      }

      /*
       * 0 darf nicht durch normalizeQty(),
       * weil 0 = Artikel entfernen.
       */
            pendingQty[line] = 0;

      updateLineDisplay(
        line,
        0
      );

      var removeItemEl = getItemEl(line);
      if (removeItemEl) removeItemEl.classList.add('is-loading');
      announce('Artikel wird entfernt');

      commitChange(
        line,
        0
      );
    }
  }

  function onQtyInputChange(e) {
    var input = e.target;

    if (
      !input ||
      !input.matches(
        '[data-qty-input]'
      )
    ) {
      return;
    }

    var itemEl =
      input.closest
        ? input.closest(
            '[data-cart-item]'
          )
        : null;

    if (!itemEl) {
      return;
    }

    var line =
      itemEl.getAttribute(
        'data-line'
      );

    if (!line) {
      return;
    }

    var qty =
      normalizeQty(
        input.value
      );

    input.value =
      String(qty);

    scheduleChange(
      line,
      qty
    );
  }

  // ─────────────────────────────────────────────
  // Focus Trap
  // ─────────────────────────────────────────────

  function trapFocus(event) {
    if (
      !drawerEl ||
      drawerEl.getAttribute(
        'aria-hidden'
      ) !== 'false' ||
      event.key !== 'Tab'
    ) {
      return;
    }

    var focusable =
      drawerEl.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

    if (
      !focusable.length
    ) {
      return;
    }

    var first =
      focusable[0];

    var last =
      focusable[
        focusable.length - 1
      ];

    var active =
      document.activeElement;

    if (
      event.shiftKey &&
      active === first
    ) {
      event.preventDefault();
      safeFocus(last);
    } else if (
      !event.shiftKey &&
      active === last
    ) {
      event.preventDefault();
      safeFocus(first);
    }
  }

  // ─────────────────────────────────────────────
  // Event Binding
  // ─────────────────────────────────────────────

  function bindEvents() {
    document
      .querySelectorAll(
        '[data-cart-open]'
      )
      .forEach(
        function (btn) {
          btn.addEventListener(
            'click',
            onHeaderCartClick
          );
        }
      );

    if (!drawerEl) {
      return;
    }

    drawerEl.addEventListener(
      'click',
      onDrawerClick
    );

    drawerEl.addEventListener(
      'change',
      onQtyInputChange
    );

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key ===
            'Escape' &&
          drawerEl.getAttribute(
            'aria-hidden'
          ) === 'false'
        ) {
          closeDrawer();
          return;
        }

        trapFocus(event);
      }
    );

    // ───────────────────────────────────────────
    // Add to Cart Handling
    // ───────────────────────────────────────────

    var lastATCTime = 0;
    var ATC_WINDOW_MS = 2500;

    var externalRefreshTimer =
      null;

    function markATC(trigger) {
      lastATCTime =
        Date.now();

      if (trigger) {
        lastTriggerEl =
          trigger;
      }

      /*
       * Drawer bewusst NICHT sofort öffnen.
       *
       * Wir warten auf das erfolgreiche
       * Cart-Update des Themes.
       */
    }

    document.addEventListener(
      'click',
      function (e) {
        var btn =
          e.target.closest &&
          e.target.closest(
            '.product-form--atc-button, .order-page__atc-button, button[name="add"], [data-add-to-cart]'
          );

        if (btn) {
          markATC(btn);
        }
      }
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form =
          e.target.closest &&
          e.target.closest(
            'form[action*="/cart/add"], form[data-product-form]'
          );

        if (form) {
          markATC(
            form.querySelector(
              'button[type="submit"], [data-add-to-cart]'
            ) || form
          );
        }
      }
    );

    // ───────────────────────────────────────────
    // External cartcount:update
    // ───────────────────────────────────────────

    window.addEventListener(
      'cartcount:update',
      function (event) {
        var detail =
          event &&
          event.detail;

        /*
         * Eigene Events ignorieren.
         */
        if (
          detail &&
          detail.source ===
            'kg-cart-drawer'
        ) {
          return;
        }

        if (
          atcBehavior !==
          'drawer'
        ) {
          return;
        }

        /*
         * Nur Cart-Updates beachten,
         * die direkt nach einem
         * Add-to-Cart erfolgt sind.
         */
        if (
          Date.now() -
            lastATCTime >=
          ATC_WINDOW_MS
        ) {
          return;
        }

        if (
          externalRefreshTimer
        ) {
          clearTimeout(
            externalRefreshTimer
          );
        }

        /*
         * 120 ms Puffer für Theme /
         * Shopify ATC-Verarbeitung.
         */
        externalRefreshTimer =
          setTimeout(
            function () {
              requestCartRefresh({
                preservePending: true
              })
                .then(function () {
                  /*
                   * Erst nachdem Cart
                   * aktuell und gerendert ist
                   * wird der Drawer geöffnet.
                   */
                  openDrawer();
                })
                .catch(function () {
                  /*
                   * Bei Netzwerkfehler
                   * trotzdem öffnen.
                   */
                  openDrawer();
                });
            },
            120
          );
      }
    );

    // ───────────────────────────────────────────
    // Browser Back / Forward Cache
    // ───────────────────────────────────────────

    window.addEventListener(
      'pageshow',
      function (event) {
        var navEntries =
          performance.getEntriesByType &&
          performance.getEntriesByType(
            'navigation'
          );

        var isBackForward =
          event.persisted ||
          (
            navEntries &&
            navEntries[0] &&
            navEntries[0].type ===
              'back_forward'
          );

        if (isBackForward) {
          requestCartRefresh({
            preservePending: false
          })
            .then(function () {
              if (
                window.Shopify &&
                Shopify.PaymentButton
              ) {
                Shopify.PaymentButton.init();
              }
            })
            .catch(function () {});
        }
      }
    );
  }

  // ─────────────────────────────────────────────
  // Init
  // ─────────────────────────────────────────────

  if (
    behavior === 'drawer' ||
    atcBehavior === 'drawer'
  ) {
    bindEvents();
  }
})();